const whatsAppProductIds = {
	BASIC: [
		899323,
		899324,
		899325,
		'price_1OMUuUHLoQP2SJgK33wUfLyO', // plano antigo
		'price_1OMUuUHLoQP2SJgK86RYeseh', // plano antigo
		'price_1OwVnTHLoQP2SJgKKFApejcx', // plano antigo
		'price_1OwVnTHLoQP2SJgKb9tB7VSS', // plano antigo
		'price_1Qz8b7HLoQP2SJgKutqwkJ16',
		'price_1Qz8bLHLoQP2SJgKIJvrhCcc',
		'price_1QzirPHLoQP2SJgKBoTzfbQG',
		'price_1QzirWHLoQP2SJgKgRsPDTg2',
		'price_1RsTQaHLoQP2SJgK24DmvssY', // Modo teste
		'price_1RsTQlHLoQP2SJgKbwxZjLYI', // Modo teste
		'price_1Rr0LlHLoQP2SJgK9u22JEki', // Modo teste
		'price_1Rr0M1HLoQP2SJgKif6Ga6mY', // Modo teste
		'price_1RrPpvHLoQP2SJgK2US3RE9W', // Atualização preço 04/08/25
		'price_1RrPqCHLoQP2SJgKSyrS0WZT', // Atualização preço 04/08/25
		'price_1RrPqdHLoQP2SJgKoFgadcIG', // Atualização preço 04/08/25
		'price_1RrPqsHLoQP2SJgK7jXMIeg8', // Atualização preço 04/08/25
		'price_1TyYnwHLoQP2SJgKmITpMZyO', // Recorrência bianual - Modo teste (INOV-576)
		'price_1TyYp4HLoQP2SJgKJSES1bA3', // Recorrência bianual, número adicional - Modo teste (INOV-576)
		'price_1Tyvb7HLoQP2SJgKvgBtVCqa', // Recorrência bianual - Produção (INOV-576)
		'price_1TyvcxHLoQP2SJgKGbKCAVDF', // Recorrência bianual, número adicional - Produção (INOV-576)
	],
	PRO: [
		899326,
		899327,
		899328,
		'price_1OMUtGHLoQP2SJgKtLRF57r6', // plano antigo
		'price_1OMUtGHLoQP2SJgKft2Zhb2F', // plano antigo
		'price_1OwVnXHLoQP2SJgKDVykBIT8', // plano antigo
		'price_1OwVnXHLoQP2SJgKK9WgltLB', // plano antigo
		'price_1Qz8ZhHLoQP2SJgKrTwJMwQN',
		'price_1Qz8ZuHLoQP2SJgKZ68nUCBj',
		'price_1QziqsHLoQP2SJgKhMfkpPVx',
		'price_1QziqmHLoQP2SJgK15x0fJwI',
		'price_1TyYn8HLoQP2SJgKjxmeIpoy', // Recorrência bianual - Modo teste (INOV-576)
		'price_1TyYpsHLoQP2SJgK1IWf2mf9', // Recorrência bianual, número adicional - Modo teste (INOV-576)
		'price_1TyvY4HLoQP2SJgK504WMRJ9', // Recorrência bianual - Produção (INOV-576)
		'price_1TyvZRHLoQP2SJgKngD59Hv4', // Recorrência bianual, número adicional - Produção (INOV-576)
		'price_1U0iQGHLoQP2SJgKXjtJHpzI', // Anual, produto próprio - Produção
		'price_1U0iX8HLoQP2SJgK54s5vUbU', // Anual, número adicional, produto próprio - Produção
		'price_1U0iZbHLoQP2SJgKXFscwHkt', // Bianual, produto próprio - Produção
		'price_1U0iaiHLoQP2SJgK4QOIi4JB', // Bianual, número adicional, produto próprio - Produção
		'price_1U0kuGHLoQP2SJgKd4f1x5St', // Anual, produto próprio - Modo teste
		'price_1U0kunHLoQP2SJgKP9zMOTZg', // Anual, número adicional, produto próprio - Modo teste
		'price_1U0kvDHLoQP2SJgKXjaCGFK0', // Bianual, produto próprio - Modo teste
		'price_1U0kvgHLoQP2SJgK6mZeD0YO', // Bianual, número adicional, produto próprio - Modo teste
	],
};

export { whatsAppProductIds };
